import script from "./ClassifierComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClassifierComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ClassifierComponent.vue?vue&type=style&index=0&id=7b53b33c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b53b33c"]])

export default __exports__